import React, { FunctionComponent, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { IProceduresFormData } from 'views/ProceduresView/components/ProceduresForm/types';
import { onDeleteFile, onGetForm, onGetOne, onSave } from 'redux/actions/procedures.actions';
import {
  proceduresFormSelector,
  proceduresStatesSelector,
  proceduresFilesSelector,
} from 'redux/selectors/procedures.selector';

import LayoutContainer from 'containers/LayoutContainer';
import ProceduresForm from 'views/ProceduresView/components/ProceduresForm';
import Dialog from 'components/commons/Dialog';
import Loading from 'components/commons/Loading';

import 'views/ProceduresView/components/ProceduresForm/i18n';
import { IOption } from 'types/common.types';

const ProceduresFormContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const [deleteItem, setDeleteItem] = useState<IOption | undefined>();
  const { id = '' } = useParams<{ id?: string }>();
  const initialValues = useTypedSelector(proceduresFormSelector);
  const { loading } = useTypedSelector((state) => state.procedures);
  const states = useTypedSelector(proceduresStatesSelector);
  const files = useTypedSelector(proceduresFilesSelector);
  const isEditing = !!id;

  useEffect(() => {
    dispatch(onGetForm());
    if (id) dispatch(onGetOne(id));
    return () => {
      dispatch(onGetOne(''));
    };
  }, [dispatch, id]);

  const onSubmit = (formData: IProceduresFormData) => dispatch(onSave(formData, id));

  const onDeleteClick = (isConfirmed = false) => {
    if (isConfirmed && deleteItem) dispatch(onDeleteFile(id, `${deleteItem.data}`));
    setDeleteItem(undefined);
  };

  return (
    <LayoutContainer auth title={i18next.t<string>('PROCEDURES_FORM:TITLE')}>
      <ProceduresForm
        files={files}
        initialValues={initialValues}
        isEditing={isEditing}
        onDeleteFile={setDeleteItem}
        onSubmit={onSubmit}
        states={states}
      />
      <Dialog
        message={i18next.t<string>('PROCEDURES_FORM:DELETE_DIALOG_MESSAGE', {
          name: deleteItem?.label,
        })}
        onCancelClick={() => onDeleteClick()}
        onConfirmClick={() => onDeleteClick(true)}
        open={!!deleteItem}
        title={i18next.t<string>('PROCEDURES_FORM:DELETE_DIALOG_TITLE')}
      />
      {loading && <Loading isModalMode message={i18next.t<string>('PROCEDURES_FORM:LOADING')} />}
    </LayoutContainer>
  );
};

export default ProceduresFormContainer;
